import React, { useState, useEffect } from "react";
import { useApi } from "../../services/api";
import { Card, CardTitle, CardBody } from "reactstrap";
import { Piechart } from "./Piechart";

export const Salesgrade = () => {
  const { apiFetch } = useApi();
  const [calculateShare, setCalculateShare] = useState(null);
  useEffect(() => {
    async function loadData() {

      apiFetch("/api/home/calculateShare")
        .then((response) => response.json())
        .then((data) => {
          setCalculateShare(data);
          //console.log(data,'api')
          if(data.message === "No transactions found for the specified account")
          setCalculateShare(null);
             else
             setCalculateShare(data);

        })
        .catch((error) => {
          console.error("Error loading sales grade share", error);
        })
        
    }
    loadData();
  }, []);
  return (
    <>
    <Card className="shadow">
            <CardBody>
              <CardTitle
                style={{ textAlign: "left" }}
                className="card-title-prices"
                data-testid="salesgradetext"
              >
                 Sales Grade (%) 
              </CardTitle>
             <Piechart data={calculateShare} data-testid="piechart"/>
            </CardBody>
          </Card>
      
     
    </>
  );
};
